module.exports = __webpack_public_path__ + "img/symbol_0.fccf1ec9.png";